var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.815 10.046C19.0683 10.4013 19.195 10.579 19.195 10.8419C19.195 11.1048 19.0683 11.2825 18.815 11.6377C17.6766 13.234 14.7693 16.6752 10.8617 16.6752C6.95397 16.6752 4.04674 13.234 2.90835 11.6377C2.655 11.2825 2.52832 11.1048 2.52832 10.8419C2.52832 10.579 2.655 10.4013 2.90835 10.046C4.04674 8.44975 6.95397 5.00854 10.8617 5.00854C14.7693 5.00854 17.6766 8.44975 18.815 10.046Z",
    stroke: "#7E7E81",
    strokeWidth: 1.2619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3616 10.842C13.3616 9.46129 12.2423 8.34204 10.8616 8.34204C9.48082 8.34204 8.36157 9.46129 8.36157 10.842C8.36157 12.2228 9.48082 13.342 10.8616 13.342C12.2423 13.342 13.3616 12.2228 13.3616 10.842Z",
    stroke: "#7E7E81",
    strokeWidth: 1.2619
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d6d349c17e20b73d70826f7bb82b8973.svg";
export { ForwardRef as ReactComponent };